import styled from 'styled-components';

const ConferenceRoomsView = styled.article`
  width: 100%;
  --blueBg: #c9e6ff;
  .floor {
    position: relative;
    width: 100%;
    margin: 0 auto;
    height: 650px;
    display: flex;
    flex-flow: row wrap;
    border: 4px solid ${props => props.theme.colors.primary};
    border-right: 4px dashed ${props => props.theme.colors.primary};
    background: var(--blueBg);

    @media (min-width: ${props => props.theme.breakpoints.md}) {
      height: 350px;
      border: 4px solid ${props => props.theme.colors.primary};
      border-bottom: 4px dashed ${props => props.theme.colors.primary};
    }
  }

  .room-wrapper {
    position: relative;
  }

  @keyframes slide-up {
    0% {
      right: 0;
      bottom: 0;
    }
  }

  .room {
    position: absolute;
    border: 4px solid ${props => props.theme.colors.primary};
    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
    font-size: 12px;
    background: ${props => props.theme.colors.lightGray};
    color: black;
    min-width: 50px;
    transition: all 0.2s;
    animation: slide-up 0.4s ease;

    @media (min-width: ${props => props.theme.breakpoints.mdUp}) {
      &:not(.main):not(.disabled):hover {
        background: ${props => props.theme.colors.darkenGray};

        .tooltip {
          visibility: visible;
          opacity: 1;
        }

        .door {
          background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"> <path fill="%232876BC" d="M1 1.03c9.68.5 17.47 8.29 17.97 17.97H1V1.03M0 0v20h20C20 8.95 11.05 0 0 0z"/> <path fill="%23d9d9d9" d="M0 1v19h19C19 9.51 10.49 1 0 1z"/><path fill="%23fff" d="M.5.5h3v19h-3z"/><path fill="%232876BC" d="M3 1v18H1V1h2m1-1H0v20h4V0z"/></svg>')
            center center / cover no-repeat;
        }
      }
    }
	  
	  &.disabled {
      background: ${props => props.theme.colors.darkenGray};
      cursor: not-allowed;
      opacity: .7;

      .door {
        background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"> <path fill="%232876BC" d="M1 1.03c9.68.5 17.47 8.29 17.97 17.97H1V1.03M0 0v20h20C20 8.95 11.05 0 0 0z"/> <path fill="%23d9d9d9" d="M0 1v19h19C19 9.51 10.49 1 0 1z"/><path fill="%23fff" d="M.5.5h3v19h-3z"/><path fill="%232876BC" d="M3 1v18H1V1h2m1-1H0v20h4V0z"/></svg>')
        center center / cover no-repeat;
      }
	  }

    .room-content {
      display: flex;
      align-items: flex-start;
      justify-content: center;
      width: 100%;
      height: 100%;
      padding-top: 5px;
    }

    // decorations

    .door {
      position: absolute;
      background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"> <path fill="none" d="M0 0h20v20H0z"/>  <path fill="%232876BC" d="M1 1.03c9.68.5 17.47 8.29 17.97 17.97H1V1.03M0 0v20h20C20 8.95 11.05 0 0 0z"/> <path fill="%23f9f9f9" d="M0 1v19h19C19 9.51 10.49 1 0 1z"/><path fill="%23fff" d="M.5.5h3v19h-3z"/><path fill="%232876BC" d="M3 1v18H1V1h2m1-1H0v20h4V0z"/></svg>')
        center center / cover no-repeat;
      height: 16px;
      width: 16px;
      overflow: hidden;
      z-index: 9;
      transition: all 0.2s;

      @media (min-width: ${props => props.theme.breakpoints.md}) {
        height: 20px;
        width: 20px;
      }
    }

    // room features icons

    --iconSize: 20px;
    --iconMargin: 3px;

    .feature-icon {
      position: absolute;
      width: var(--iconSize);
      height: var(--iconSize);
      left: 3px;

      @media (max-width: ${props => props.theme.breakpoints.md}) {
        bottom: 5px;
      }

      @media (min-width: ${props => props.theme.breakpoints.md}) {
        top: 25px;
      }
    }

    .blackboard {
      background: url('data:image/svg+xml;utf8,<?xml version="1.0" encoding="iso-8859-1"?><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 128 128" style="enable-background:new 0 0 128 128;" xml:space="preserve"><g><path d="M110.375,43.333a1.75,1.75,0,0,0-1.75,1.75V57.5a1.75,1.75,0,1,0,3.5,0V45.083A1.75,1.75,0,0,0,110.375,43.333Z"/><path d="M121.5,79.25h-3.37V14a1.75,1.75,0,0,0-1.75-1.75H68.75V6.5A1.75,1.75,0,0,0,67,4.75H61A1.75,1.75,0,0,0,59.25,6.5v5.75H11.62A1.75,1.75,0,0,0,9.87,14V79.25H6.5A1.75,1.75,0,0,0,4.75,81v9A1.75,1.75,0,0,0,6.5,91.75H46.651L34.266,116.366a4.75,4.75,0,0,0,8.487,4.27L57.288,91.75H70.712l14.536,28.888a4.75,4.75,0,1,0,8.485-4.274L81.349,91.75H121.5A1.75,1.75,0,0,0,123.25,90V81A1.75,1.75,0,0,0,121.5,79.25Zm-58.75-71h2.5v4h-2.5Zm-49.38,7.5H114.63v63.5H13.37ZM39.627,119.062a1.25,1.25,0,1,1-2.233-1.125L50.569,91.75h2.8Zm50.981-1.123a1.249,1.249,0,0,1-1.118,1.811,1.26,1.26,0,0,1-1.116-.687L74.63,91.75h2.8ZM119.75,88.25H8.25v-5.5h111.5Z"/></g></svg>')
        center no-repeat;
    }

    .tv {
      left: auto;
      right: -10px;
      top: 10px;
      width: 25px;
      height: 8px;
      background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"><path d="M426.812,271l-20-60H105.188l-20,60H60v30h392v-30H426.812z M116.812,271l10-30h258.377l10,30H116.812z"/></svg>')
        center center / cover no-repeat;
      transform: rotate(90deg);

      @media (min-width: ${props => props.theme.breakpoints.md}) {
        top: auto;
        left: 25px;
        width: 38px;
        height: 4px;
        transform: rotate(180deg);
        bottom: 0px;
      }
    }

    .apple-tv {
      left: calc(var(--iconSize) + 2 * var(--iconMargin));
      background: url('data:image/svg+xml;utf8,<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"><g><g><path d="M431.748,93.815c-15.928,0-30.888,6.188-42.124,17.424c-23.226,23.227-23.226,61.021,0,84.247c0,0,0.001,0,0.001,0.001l0.001,0.001c11.615,11.613,26.867,17.418,42.123,17.418c15.253,0,30.511-5.808,42.123-17.419c0.001,0,0.001,0,0.001-0.001C511.346,158.011,484.538,93.815,431.748,93.815z M395.384,179.119c-10.899-15.371-10.899-36.142-0.001-51.513l7.566,7.566c-6.992,11.069-6.992,25.311,0.001,36.379L395.384,179.119z M405.992,189.727l7.566-7.567c5.534,3.496,11.861,5.254,18.19,5.254c6.33,0,12.656-1.757,18.19-5.253l7.567,7.567C442.134,200.626,421.363,200.625,405.992,189.727z M418.266,139.881c0.001-0.001,0.003-0.003,0.004-0.005c7.435-7.428,19.527-7.428,26.959,0.005c7.434,7.434,7.434,19.529,0.001,26.963c-7.433,7.434-19.53,7.433-26.964,0C410.833,159.41,410.833,147.314,418.266,139.881z M449.937,124.565c-11.069-6.991-25.311-6.992-36.379,0l-7.569-7.569c7.47-5.307,16.386-8.18,25.759-8.18c9.374,0,18.289,2.872,25.76,8.18L449.937,124.565z M468.113,179.12l-7.567-7.567c6.992-11.069,6.992-25.311,0-36.379l7.566-7.566C479.011,142.977,479.011,163.749,468.113,179.12z"/></g></g><g><g><path d="M168.031,333.068c-10.333-4.338-11.696-18.328-2.553-24.648c5.004-3.459,5.437-10.673,0.854-14.685c-4.089-3.579-8.957-6.093-14.163-7.387c6.234-7.346,8.696-17.135,6.92-27.622c-0.813-4.802-5.099-8.538-9.969-8.69c-10.803-0.347-20.263,3.547-26.698,10.929h-0.001c-5.697,6.537-8.341,15.069-7.621,24.323c-1.209-0.142-2.413-0.242-3.587-0.254c-18.183-0.138-33.204,13.9-34.209,32.055c-2.368,26.164,16.255,48.166,19.311,51.573h-0.001c5.11,6.031,13.655,8.612,22.448,4.722c5.222-2.306,11.183-2.249,16.363,0.153c1.875,0.831,3.559,1.587,6.438,1.919c6.258,0.695,12.143-1.778,15.981-6.1c1.397-1.476,9.836-10.701,15.461-24.113C174.992,340.514,172.759,335.053,168.031,333.068z M133.732,270.822c2.658-3.049,6.447-4.971,10.913-5.587c-0.002,9.246-5.795,15.896-14.958,17.162C129.688,277.888,131.074,273.871,133.732,270.822z M146.392,359.322c-1.071,1.221-2.715,1.644-4.441,0.844c-0.348-0.079-13.472-7.467-29.244-0.505c-0.086,0.038-0.474,0.209-0.537,0.237c-1.999,0.837-3.298,0.263-4.644-1.197c-0.292-0.317-17.543-19.308-15.57-40.369c0.01-0.107,0.018-0.213,0.022-0.32c0.559-11.047,10.459-19.489,21.808-17.746c1.06,0.161,2.136,0.404,3.144,0.761c0.331,0.122,0.469,0.127,1.486,0.567c0.253,0.108,0.517,0.22,1.026,0.478c13.824,7.404,17.316-5.985,31.477-0.417c-10.623,13.051-8.13,32.683,6.087,42.406C154.191,349.495,150.828,354.345,146.392,359.322z"/></g></g><g><g><path d="M203.263,347.373v-33.767h17.164c2.834,0,4.08-2.988,4.08-5.486c0-2.522-1.257-5.487-4.08-5.487h-17.164v-25.747c0-3.659-6.954-6.609-12.452-3.446c-1.547,0.893-2.321,2.04-2.321,3.446v70.487c0,7.691,2.086,13.273,6.261,16.742c7.908,6.578,20.445,4.947,23.284,5.205c6.175,0,7.967-6.634,4.783-10.693C218.443,353.072,203.263,362.568,203.263,347.373z"/></g></g><g><g><path d="M289.296,305.939c-2.94-3.324-11.398-6.194-13.155-0.915l-16.742,44.178c-17.685-46.14-16.342-45.549-18.501-46.569c-1.809-0.846-4.062-0.627-5.979-0.07c-3.43,1.006-7.308,3.615-6.26,7.104c0.141,0.471,0.303,0.845,0.492,1.126c25.142,59.552,22.499,57.872,26.028,59.231c3.304,1.272,9.488,1.013,10.975-2.251l23.636-56.98C290.557,308.863,290.661,307.487,289.296,305.939z"/></g></g><g><g><path d="M401.747,231.946c-13.249,0-24.026,10.778-24.026,24.026c0,13.249,10.778,24.027,24.026,24.027c13.249,0,24.027-10.778,24.027-24.027C425.775,242.723,414.996,231.946,401.747,231.946z M401.746,264.998c-4.976,0-9.026-4.048-9.026-9.026c0-4.977,4.049-9.026,9.026-9.026c4.978,0,9.027,4.049,9.027,9.026C410.773,260.948,406.724,264.998,401.746,264.998z"/></g></g><g><g><path d="M461.75,231.946c-13.249,0-24.027,10.778-24.027,24.026c0,13.249,10.779,24.027,24.027,24.027c13.249,0,24.026-10.778,24.026-24.027C485.776,242.723,474.999,231.946,461.75,231.946z M461.75,264.998c-4.978,0-9.027-4.049-9.027-9.026c0-4.976,4.049-9.026,9.027-9.026s9.026,4.049,9.026,9.026C470.776,260.948,466.726,264.998,461.75,264.998z"/></g></g><g><g><path d="M461.75,431.983h-60.003c-4.143,0-7.5,3.357-7.5,7.5c0,4.143,3.357,7.5,7.5,7.5h60.003c4.143,0,7.5-3.357,7.5-7.5C469.25,435.34,465.893,431.983,461.75,431.983z"/></g></g><g><g><path d="M248.804,483.193H75.428c-33.32,0-60.427-27.107-60.427-60.427V207.123c0-33.319,27.107-60.427,60.427-60.427h8.869c4.143,0,7.5-3.357,7.5-7.5s-3.357-7.5-7.5-7.5h-8.869C33.837,131.696,0,165.533,0,207.123v215.643c0,41.591,33.837,75.428,75.428,75.428h173.377c4.143,0,7.5-3.357,7.5-7.5C256.305,486.551,252.947,483.193,248.804,483.193z"/></g></g><g><g><path d="M504.5,77.994c4.142,0,7.5-3.357,7.5-7.5V46.712c0-18.175-14.787-32.962-32.962-32.962h-94.579c-18.175,0-32.962,14.787-32.962,32.962v115.316c-13.768-18.401-35.73-30.332-60.427-30.332H119.298c-4.143,0-7.5,3.357-7.5,7.5c0,4.143,3.357,7.5,7.5,7.5h171.772c33.319,0,60.427,27.107,60.427,60.427v215.643c0,33.319-27.107,60.427-60.427,60.427h-7.264c-4.143,0-7.5,3.358-7.5,7.5c0,4.143,3.357,7.5,7.5,7.5c2.326-0.516,41.255,5.166,67.794-30.477c1.276,17.017,15.521,30.477,32.859,30.477h94.579c18.175,0,32.962-14.787,32.962-32.962V105.496c0-4.143-3.358-7.5-7.5-7.5c-4.143,0-7.5,3.357-7.5,7.5v359.736c0,9.904-8.057,17.961-17.961,17.961h-94.579c-9.904,0-17.961-8.057-17.961-17.961c0-18.538,0-398.791,0-418.519c0-9.904,8.057-17.961,17.961-17.961h94.579c9.904,0,17.961,8.057,17.961,17.961v23.781C496.999,74.637,500.356,77.994,504.5,77.994z"/></g></g></svg>')
        center center / 20px no-repeat;
    }

    .two-monitors {
      left: calc(2 * var(--iconSize) + 3 * var(--iconMargin));
      background: blue;
      background: url('data:image/svg+xml;utf8,<svg width="512" height="512" xmlns="http://www.w3.org/2000/svg"><polygon stroke="null" id="svg_1" points="23.92106056213379,120.73939895629883 279.79296875,120.73939895629883 279.79296875,187.04333114624023 301.7140197753906,187.04333114624023 301.7140197753906,98.82915496826172 2,98.82915496826172 2,290.84121322631836 124.33402252197266,290.84121322631836 124.33402252197266,303.20222091674805 60.38767623901367,303.20222091674805 60.38767623901367,313.4003715515137 212.56980895996094,313.4003715515137 212.56980895996094,303.20222091674805 176.87103271484375,303.20222091674805 176.87103271484375,290.84121322631836 212.56980895996094,290.84121322631836 212.56980895996094,262.5612144470215 23.92106056213379,262.5612144470215 "/> <path stroke="null" id="svg_2" d="m508.21398,378.84758l0,-186.24619l-290.71399,0l0,186.24619l118.66049,0l0,12.01081l-62.01563,0l0,9.87089l173.67943,0l0,-9.87089l-60.68343,0l0,-12.01081l121.07314,0zm-269.45119,-27.40982l0,-137.57357l248.18839,0l0,137.55259l-248.18839,0l0,0.02098z"/></svg>')
        center center / cover no-repeat;
    }

    /* .projector {
      width: 20px;
      height: 20px;
      background: blue;
    } */

    // rooms sizes and positions

    &.main {
      top: 22%;
      right: -4px;
      width: 40%;
      height: 51%;
      background: var(--blueBg);
      text-align: center;

      @media (max-width: ${props => props.theme.breakpoints.sm}) {
        border-right: none;
      }

      @media (min-width: ${props => props.theme.breakpoints.md}) {
        bottom: -4px;
        right: 25%;
        top: auto;
        left: auto;
        width: 51%;
        height: 38%;
        border-bottom: none;
      }

      .door {
        left: -4px;
        top: 50%;
        transform: rotate(90deg) scaleY(1);
        background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"> <path fill="none" d="M0 0h20v20H0z"/>  <path fill="%232876BC" d="M1 1.03c9.68.5 17.47 8.29 17.97 17.97H1V1.03M0 0v20h20C20 8.95 11.05 0 0 0z"/> <path fill="%23c9e6ff" d="M0 1v19h19C19 9.51 10.49 1 0 1z"/><path fill="%23fff" d="M.5.5h3v19h-3z"/><path fill="%232876BC" d="M3 1v18H1V1h2m1-1H0v20h4V0z"/></svg>')
          center center / cover no-repeat;

        @media (min-width: ${props => props.theme.breakpoints.md}) {
          top: -4px;
          left: 46%;
          right: auto;
          bottom: auto;
          transform: rotate(0deg) scale(-1);
        }
      }
    }

    &.oregano {
      top: -4px;
      right: 9%;
      width: 42%;
      height: 13%;

      @media (min-width: ${props => props.theme.breakpoints.md}) {
        bottom: 10%;
        top: auto;
        right: -4px;
        width: 14%;
        height: 44%;
      }

      .door {
        bottom: -4px;
        right: 2px;
        transform: scaleX(-1);

        @media (min-width: ${props => props.theme.breakpoints.md}) {
          bottom: 4px;
          left: -4px;
          right: auto;
          transform: rotate(90deg) scaleX(-1);
        }
      }
    }

    &.bazylia {
      bottom: 63.5%;
      left: -4px;
      width: 38%;
      height: 13%;

      @media (min-width: ${props => props.theme.breakpoints.md}) {
        top: -4px;
        right: 24%;
        bottom: auto;
        left: auto;
        width: 13%;
        height: 32%;
      }

      .door {
        bottom: 2px;
        right: -4px;
        transform: rotate(90deg) scale(-1);

        @media (min-width: ${props => props.theme.breakpoints.md}) {
          bottom: -4px;
          left: 4px;
          transform: rotate(0);
        }
      }
    }

    &.reception {
      bottom: 53.5%;
      left: -4px;
      height: 11%;
      width: 38%;
      background: var(--blueBg);
      pointer-events: none;

      @media (max-width: ${props => props.theme.breakpoints.sm}) {
        border-right: none;
      }

      @media (min-width: ${props => props.theme.breakpoints.md}) {
        top: -4px;
        right: 36.5%;
        bottom: auto;
        left: auto;
        width: 10%;
        height: 32%;
        border-bottom: none;
      }

      &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 90%;
        width: 50%;
        height: 100%;
        background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="480pt" viewBox="0 0 480 480" width="480pt"><path d="m288 8c-48.601562 0-88 39.398438-88 88 .007812 31.792969 5.140625 63.375 15.199219 93.535156l.800781 2.464844v24h144v-24l.800781-2.464844c10.058594-30.160156 15.191407-61.742187 15.199219-93.535156 0-48.601562-39.398438-88-88-88zm0 0" fill="%23fff"/><path d="m288 8c-8.117188.015625-16.195312 1.160156-24 3.398438 37.84375 10.730468 63.972656 45.265624 64 84.601562-.007812 31.792969-5.140625 63.375-15.199219 93.535156l-.800781 2.464844v24h48v-24l.800781-2.464844c10.058594-30.160156 15.191407-61.742187 15.199219-93.535156 0-48.601562-39.398438-88-88-88zm0 0" fill="%23d7d7d7"/><path d="m432 216h16v24h-16zm0 0" fill="%23f79d1e"/><path d="m8 280h464v32h-464zm0 0" fill="%23fff"/><path d="m8 312h464v160h-464zm0 0" fill="%23fff"/><path d="m328 184h-16v-5.464844c19.535156-9.246094 31.992188-28.921875 32-50.535156v-56l-112 24v32c.007812 21.613281 12.464844 41.289062 32 50.535156v5.464844h-16c-26.507812 0-48 21.492188-48 48v48h176v-48c0-26.507812-21.492188-48-48-48zm0 0" fill="%23fff"/><path d="m328 184h-8l-32 40-32-40h-8c-26.507812 0-48 21.492188-48 48v48h176v-48c0-26.507812-21.492188-48-48-48zm0 0" fill="%23fff"/><path d="m24 136h128c8.835938 0 16 7.164062 16 16v80c0 8.835938-7.164062 16-16 16h-128c-8.835938 0-16-7.164062-16-16v-80c0-8.835938 7.164062-16 16-16zm0 0" fill="%23fff"/><path d="m440 232c17.671875 0 32 14.328125 32 32v16h-64v-16c0-17.671875 14.328125-32 32-32zm0 0" fill="%23fff"/><path d="m440 232c-4.117188.015625-8.191406.832031-12 2.398438 12.066406 4.882812 19.972656 16.585937 20 29.601562v16h24v-16c0-17.671875-14.328125-32-32-32zm0 0" fill="%23d7d7d7"/><path d="m32 368h16v48h-16zm0 0" fill="%23db9160"/><path d="m32 336h16v16h-16zm0 0" fill="%23db9160"/><path d="m8 304h464v24h-464zm0 0" fill="%23d7d7d7"/><path d="m31.121094 248h120.878906c8.835938 0 16-7.164062 16-16v-58.015625c-36.800781 39.6875-99.359375 62.945313-136.878906 74.015625zm0 0" fill="%23d7d7d7"/><path d="m88 280h-48l24-64h48zm0 0" fill="%23fff"/><path d="m256 104h16v16h-16zm0 0" fill="%237a4321"/><path d="m304 104h16v16h-16zm0 0" fill="%237a4321"/><path d="m288 160c-13.253906 0-24-10.746094-24-24h16c0 4.417969 3.582031 8 8 8s8-3.582031 8-8h16c0 13.253906-10.746094 24-24 24zm0 0" fill="%23fa996b"/><path d="m216.414062 280h159.585938v-48c.007812-11.417969-4.070312-22.460938-11.503906-31.128906-40.183594 47.609375-102.710938 69.3125-148.082032 79.128906zm0 0" fill="%23d7d7d7"/><g fill="%232e7db3"><path d="m328 240h16v40h-16zm0 0"/><path d="m232 240h16v40h-16zm0 0"/><path d="m296 280h-16v-48c0-4.417969 3.582031-8 8-8s8 3.582031 8 8zm0 0"/></g><path d="m256 104h16v16h-16zm0 0"/><path d="m304 104h16v16h-16zm0 0"/><path d="m288 144c-4.417969 0-8-3.582031-8-8h-16c0 13.253906 10.746094 24 24 24s24-10.746094 24-24h-16c0 4.417969-3.582031 8-8 8zm0 0"/><path d="m448 224.800781v-16.800781h-16v16.800781c-18.613281 3.828125-31.976562 20.199219-32 39.199219v8h-16v-40c0-14.578125-5.707031-28.582031-15.894531-39.007812l.300781-.929688c10.339844-30.96875 15.605469-63.410156 15.59375-96.0625 0-53.019531-42.980469-96-96-96s-96 42.980469-96 96c-.011719 32.652344 5.25 65.089844 15.585938 96.0625l.308593.9375c-10.191406 10.421875-15.894531 24.421875-15.894531 39v40h-92.457031l6-16h46.457031c13.253906 0 24-10.746094 24-24v-80c0-13.253906-10.746094-24-24-24h-128c-13.253906 0-24 10.746094-24 24v80c0 13.253906 10.746094 24 24 24h16.457031l-6 16h-26.457031c-4.417969 0-8 3.582031-8 8v192c0 4.417969 3.582031 8 8 8h464c4.417969 0 8-3.582031 8-8v-208c-.023438-19-13.386719-35.371094-32-39.199219zm-160-208.800781c44.164062.046875 79.953125 35.835938 80 80-.007812 29.425781-4.539062 58.671875-13.441406 86.71875-7.542969-4.0625-15.921875-6.324219-24.488282-6.613281 13.925782-12.109375 21.921876-29.652344 21.929688-48.105469v-56c0-2.417969-1.089844-4.703125-2.972656-6.222656-1.878906-1.519532-4.34375-2.109375-6.707032-1.601563l-112 24c-3.6875.792969-6.320312 4.050781-6.320312 7.824219v32c.007812 18.453125 8.003906 35.996094 21.929688 48.105469-8.566407.289062-16.949219 2.554687-24.496094 6.613281-8.894532-28.046875-13.425782-57.292969-13.433594-86.71875.046875-44.164062 35.835938-79.953125 80-80zm40 224v32h-32v-45.191406l27.847656-34.808594h4.152344c22.082031.027344 39.972656 17.917969 40 40v40h-24v-32zm-24.648438-48-15.351562 19.199219-15.351562-19.199219zm-63.351562-64v-25.527344l96-20.578125v46.105469c0 26.507812-21.492188 48-48 48s-48-21.492188-48-48zm-32 104c.027344-22.082031 17.917969-39.972656 40-40h4.152344l27.847656 34.808594v45.191406h-32v-32h-16v32h-24zm-125.542969 40h-30.914062l18-48h30.914062zm-58.457031-32c-4.417969 0-8-3.582031-8-8v-80c0-4.417969 3.582031-8 8-8h128c4.417969 0 8 3.582031 8 8v80c0 4.417969-3.582031 8-8 8h-40.457031l7.953125-21.191406c.921875-2.457032.578125-5.210938-.917969-7.367188s-3.953125-3.441406-6.578125-3.441406h-48c-3.335938-.003906-6.324219 2.066406-7.496094 5.191406l-10.046875 26.808594zm440 224h-448v-144h448zm0-160h-448v-16h448zm0-32h-48v-8c0-13.253906 10.746094-24 24-24s24 10.746094 24 24zm0 0"/><path d="m32 368h16v48h-16zm0 0"/><path d="m32 336h16v16h-16zm0 0"/></svg>')
          left center / 30px no-repeat;

        @media (min-width: ${props => props.theme.breakpoints.md}) {
          top: 70%;
          left: 0;
          width: 100%;
          height: 50%;
          background-position: center center;
          background-size: 40%;
        }

        @media (min-width: ${props => props.theme.breakpoints.xxl}) {
          background-size: 35%;
        }
      }
    }

    &.kolendra {
      bottom: 42.5%;
      left: -4px;
      width: 38%;
      height: 12%;

      @media (min-width: ${props => props.theme.breakpoints.md}) {
        top: -4px;
        right: 46%;
        bottom: auto;
        left: auto;
        width: 12%;
        height: 32%;
      }

      .door {
        bottom: 2px;
        right: -4px;
        transform: rotate(90deg) scale(-1);

        @media (min-width: ${props => props.theme.breakpoints.md}) {
          bottom: -4px;
          left: 4px;
          transform: rotate(0);
        }
      }
    }

    &.chilli {
      bottom: calc(34% - 2px);
      left: -4px;
      width: 38%;
      height: 9.5%;

      @media (min-width: ${props => props.theme.breakpoints.md}) {
        top: -4px;
        right: calc(58% - 4px);
        bottom: auto;
        left: auto;
        width: 10%;
        height: 32%;
      }

      .door {
        top: 2px;
        right: -4px;
        transform: rotate(90deg) scaleY(-1);

        @media (min-width: ${props => props.theme.breakpoints.md}) {
          bottom: -4px;
          top: auto;
          right: 4px;
          transform: rotate(0deg) scaleX(-1);
        }
      }

      .tv {
        top: auto;
        bottom: 3px;

        @media (min-width: ${props => props.theme.breakpoints.md}) {
          top: -2px;
          left: auto;
          right: 5px;
          width: 30px;
          height: 4px;
        }
      }
    }

    &.estragon {
      bottom: 23.5%;
      left: -4px;
      width: 38%;
      height: 11%;

      @media (min-width: ${props => props.theme.breakpoints.md}) {
        top: -4px;
        right: 67%;
        bottom: auto;
        left: auto;
        width: 10%;
        height: 32%;
      }

      .door {
        bottom: 2px;
        right: -4px;
        transform: rotate(90deg) scale(-1);

        @media (min-width: ${props => props.theme.breakpoints.md}) {
          bottom: -4px;
          left: 4px;
          right: auto;
          transform: rotate(0);
        }
      }
    }

    &.indygo {
      bottom: calc(14% + 1px);
      left: -4px;
      width: 38%;
      height: 10%;

      @media (min-width: ${props => props.theme.breakpoints.md}) {
        top: -4px;
        right: 76.5%;
        bottom: auto;
        left: auto;
        width: 9%;
        height: 32%;
      }

      .door {
        top: 2px;
        right: -4px;
        transform: rotate(90deg) scaleY(-1);

        @media (min-width: ${props => props.theme.breakpoints.md}) {
          bottom: -4px;
          top: auto;
          right: 4px;
          transform: rotate(0deg) scaleX(-1);
        }
      }

      .tv {
        top: 25px;

        @media (min-width: ${props => props.theme.breakpoints.md}) {
          top: auto;
          left: 0;
        }
      }
    }

    &.curry {
      bottom: -4px;
      right: 16%;
      width: 42%;
      height: 15.5%;

      @media (min-width: ${props => props.theme.breakpoints.md}) {
        bottom: 20%;
        left: -4px;
        right: auto;
        width: 15.5%;
        height: 36%;
      }

      .room-content {
        @media (max-width: ${props => props.theme.breakpoints.sm}) {
          padding-top: 20px;
        }

        @media (min-width: ${props => props.theme.breakpoints.md}) {
          padding-right: 20px;
        }
      }

      &:after {
        content: '';
        position: absolute;
        top: -4px;
        left: -4px;
        display: block;
        width: 38%;
        height: 26%;
        border: 4px solid ${props => props.theme.colors.primary};
        border-top: none;
        border-left: none;
        background-color: var(--blueBg);

        @media (min-width: ${props => props.theme.breakpoints.md}) {
          top: -4px;
          right: -4px;
          left: auto;
          width: 30%;
          height: 33%;
          border: 4px solid ${props => props.theme.colors.primary};
          border-right: none;
          border-top: none;
        }
      }

      .door {
        left: calc(38% - 8px);
        top: -1px;
        transform: rotate(90deg) scaleY(1);

        @media (min-width: ${props => props.theme.breakpoints.md}) {
          top: 26%;
          right: 4px;
          left: auto;
          transform: rotate(0deg) scale(-1);
        }
      }
    }
  }
`;

export { ConferenceRoomsView };
